import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import QuotationsActions from 'app/actions/QuotationsActions';
import UgcEditorActions from 'app/actions/UgcEditorActions';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectQuotationsTransactions } from 'app/selectors/ugc/QuotationsSelector';
import { selectQuotationEntities } from 'app/selectors/EntitiesSelector';
import { selectOpenUgcEditors } from 'app/selectors/ui/UgcEditorSelector';
import QuotationEditor from './QuotationEditor';

export class QuotationEditorContainer extends React.PureComponent {
  render() {
    return <QuotationEditor {...this.props} />;
  }
}

QuotationEditorContainer.propTypes = {
  // ownProps
  catalogBib: catalogBibShape,
  quotationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleSuccess: PropTypes.func,
  handleCancel: PropTypes.func,

  // Props from Redux store
  open: PropTypes.bool,
  currentUser: userIdentityShape,
  initialContent: PropTypes.string,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ugcEditorActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = (state, ownProps) => {
  const { quotationId } = ownProps;
  return {
    currentUser: selectCurrentUser(state),
    quotationsTransactions: selectQuotationsTransactions(state),
    initialContent: quotationId ? selectQuotationEntities(state).getIn([quotationId.toString(), 'quotation']) : '',
    open: !!quotationId || selectOpenUgcEditors(state).has('quotation')
  };
};

const mapDispatchToProps = dispatch => ({
  quotationsActions: bindActionCreators(QuotationsActions, dispatch),
  ugcEditorActions: bindActionCreators(UgcEditorActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(QuotationEditorContainer);
